<template>
    <div class="captcha">
      <input v-for="(c, index) in ct" :key="index"
        type="number" v-model="ct[index]" ref="input"
        :style="{borderBottomColor: index <= cIndex ? 'var(--input-box-background)' : ''}"
        @input="e => {onInput(e.target.value, index)}"
        @keydown.delete="e=>{onKeydown(e.target.value, index)}"
        @focus="onFocus"
        :disabled="loading"
      />
    </div>
</template>

<script>
export default {
  props: {
    codeLength: {
      type: Number,
      default: 6,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ct: ['', '', '', '', '', ''],
    };
  },
  computed: {
    ctSize() {
      return this.ct.length;
    },
    cIndex() {
      let i = this.ct.findIndex(item => item === '');
      i = (i + this.ctSize) % this.ctSize;
      return i;
    },
    lastCode() {
      return this.ct[this.ctSize - 1];
    },
  },
  watch: {
    codeLength(oldValue, newValue) {
      if (oldValue !== newValue) {
        this.reset();
      }
    },
    cIndex() {
      this.resetCaret();
    },
    lastCode(val) {
      if (val) {
        this.$refs.input[this.ctSize - 1].blur();
        this.sendCaptcha();
      }
    },
  },
  mounted() {
    this.resetCaret();
  },
  methods: {
    onInput(val, index) {
      this.msg = '';
      val = val.replace(/\s/g, '');
      if (index === this.ctSize - 1) {
        this.ct[this.ctSize - 1] = val[0]; // The last code, only one character is allowed.
      } else if (val.length > 1) {
        let i = index;
        for (i = index; i < this.ctSize && i - index < val.length; i++) {
          this.ct[i] = val[i];
        }
        this.resetCaret();
      }
      this.onTextChanged();
    },
    // Reset the cursor position.
    resetCaret() {
      this.$refs.input[this.ctSize - 1].focus();
    },
    onFocus() {
      // Listen to the focus event and reposition the cursor to "the position of the first blank character".
      let index = this.ct.findIndex(item => item === '');
      index = (index + this.ctSize) % this.ctSize;
      this.$refs.input[index].focus();
    },
    onKeydown(val, index) {
      if (val === '') {
        // Delete the value in the previous input and focus on it.
        if (index > 0) {
          this.ct[index - 1] = '';
          this.$refs.input[index - 1].focus();
        }
      }
    },
    onTextChanged() {
      this.$emit('input', this.ct.join(''));
    },
    sendCaptcha() {
      this.$emit('complete', this.ct.join(''));
    },
    reset() {
      this.ct = Array(this.codeLength).fill('');
      this.resetCaret();
      this.onTextChanged();
    },
  },
};

</script>

<style scoped>
.captcha {
  display: flex;
  justify-content: center;
  margin: 1em;
}
.captcha > input {
  margin-right: 0.5em!important;
  width: 1em!important;
  text-align: center!important;
  border: none!important;
  border-radius: 5px!important;
  font-size: 1.2em!important;
  outline: initial;

  color: var(--textColor)!important;
  border: 1px solid var(--input-border-color)!important;
}
input:last-of-type {
  margin-right: 0;
}
input:disabled {
  color: #000;
  background-color: #fff;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.msg {
  text-align: center;
}
</style>
